import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';

export const ToastContainerCustom = styled(ToastContainer)`
  .Toastify__toast-container {
    width: 400px;
    min-height: 72px;

    @media (min-width: 600px) {
      width: 472px;
      min-height: 64px;
    }
  }

  .Toastify__toast {
    background: ${({ theme }) => theme.store.background.secondary};
    border: 1px solid ${({ theme }) => theme.store.border.primary};
    box-sizing: border-box;
    box-shadow: 4px 6px 25px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .Toastify__toast--error {
  }
  .Toastify__toast--warning {
  }
  .Toastify__toast--success {
  }
  .Toastify__toast-body {
  }
  .Toastify__progress-bar {
    background: none;
    height: 0;
  }

  .Toastify__close-button {
    svg {
      fill: ${({ theme }) => theme.store.colors.textTerciary};
    }
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const Text = styled.span`
  color: ${({ theme }) => theme.store.colors.textTerciary};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  @media (min-width: 600px) {
    font-weight: 500;
  }
`;
